import { apiAction } from 'apa/actions'
import * as types from 'invoices/actions/types'
import { BaseUrl } from '../../BaseUrl/BaseUrl'


export const setSearchText = (searchText) => dispatch => dispatch(
  {
    type: types.SET_SEARCH_TEXT_INVOICES,
    searchText: searchText
  }
)

export const changeStatus = (status) => dispatch => {
    dispatch(
        {
            type: types.CHANGE_STATUS,
            status: status
        }
    )
    dispatch(fetchInvoices())
}


export const changePage = (page = 1) => dispatch => {
  dispatch({
    type: types.CHANGE_PAGE_INVOICES,
    currentPage: page
  })
  dispatch(
    fetchInvoices()
  )
}

export const fetchInvoices = () => (dispatch, getState) => {
    dispatch({
        type: types.FETCH_INVOICES
    })
    const currentPage = getState().invoices.currentPage
    const searchText = getState().invoices.searchText
    const currentYear = getState().items.currentYear;
    const status = getState().invoices.status;
    dispatch(apiAction({
      url: `${BaseUrl}/api/invoices/?page=${currentPage}&search=${searchText}&year=${currentYear}&status=${status}`,
      onSuccess: res => ({
        type: types.FETCH_INVOICE_LIST_SUCCESS,
        invoiceList: res.results,
        totalCount: res.totalCount,
        pageCount: res.pageCount,
        currentPage: res.currentPage,
        sizePerPage: res.sizePerPage
      })
    }))
}
